<template>
    <main class="dashboard">
        <div class="main-section" style=" background: rgb(248, 249, 253);">
            <div class="container has-background-white pr-3 pt-3">
                <div class="tipo_negocio">
                    <h2 class="title has-text-centered">
                        Categorías
                    </h2>
                </div>
                <div class="columns is-tablet is-multiline is-centered m-0 mt-2">
                    <div v-for="catType of getCategoryTypes()" v-bind:key="catType.type"
                        class="column is-6 is-narrow has-text-centered mb-5 box">
                        <h3 class="subtitle is-size-4 bold is-capitalized">
                            <strong>{{ catType.type }}</strong>
                        </h3>

                        <div class="content">
                            <div class="m-3" v-for="attrib of classifiedAttributes[catType.type]"
                                v-bind:key="attrib.id">
                                <div v-if="attrib.name !== ''">
                                    <div class="is-flex is-justify-content-center">
                                        <span v-if="updatedAttrib == null || updatedAttrib.id != attrib.id"
                                            class="is-capitalized mr-3">
                                            {{ attrib.name }}
                                        </span>

                                        <b-field v-if="updatedAttrib != null && updatedAttrib.id == attrib.id"
                                            class="mb-0" :label="'Actualize ' + nameBeforeUpdate"
                                            :label-for="attrib.name">
                                            <Input :inputId="attrib.name" v-model="updatedAttrib.name" placeholder=""
                                                :ref="updatedAttrib.name" />
                                            <span>
                                                <b-button @click="() => addAttribute(catType.type, updatedAttrib.id)"
                                                    class="ml-1 p-2 is-small" type="is-warning"
                                                    icon-right="pencil-ruler">
                                                    Editar
                                                </b-button>
                                                <b-button @click="() => editAttribute(null)" class="ml-1 p-2 is-small"
                                                    type="is-info" icon-right="minus">
                                                    Cancelar
                                                </b-button>
                                            </span>
                                        </b-field>

                                        <span v-if="updatedAttrib == null || updatedAttrib.id != attrib.id">
                                            <b-button @click="() => editAttribute(attrib)" class="is-small mr-1 p-2"
                                                type="is-secondary" icon-right="pencil-ruler">
                                                Editar
                                            </b-button>
                                            <b-button @click="() => deleteAttribute(attrib)" class="is-small p-2"
                                                type="is-danger" icon-right="trash">
                                                Eliminar
                                            </b-button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="is-flex is-justify-content-center mt-3">
                            <b-field class="ml-5 mb-0" :label-for="catType.type">
                                <Input :inputId="catType.type" v-model.lazy="auxInput[catType.type]" placeholder=""
                                    :ref="auxInput[catType.type]"
                                    :disabled="updatedAttrib != null && updatedAttrib.type == catType.type" />
                                <b-button type="is-flow" class="ml-4"
                                    :disabled="updatedAttrib != null && updatedAttrib.type == catType.type"
                                    @click="() => addAttribute(catType.type)">Agregar</b-button>
                            </b-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { addAttributes, deleteAttributes, getAttributes } from "@/api/carteraAnalista";
import Input from "@/components/inputs/Input";
import { consoleHandlerError, notificate } from "@/utils/message";

export default {
    name: "CompanyInfoCategories",
    components: {
        Input,
    },
    created() {
    },
    mounted() {
        this.company_id = this.$route.query.companyId;
        getAttributes(this.company_id).then(({ data }) => {
            this.allAttributes.push(...data)
        }).then(() => {
            this.initClassifiedAttributes()
        })
    },
    data() {
        return {
            allAttributes: [],
            auxInput: {
                'linea de negocio': '',
                'canal': '',
                'proyecto': '',
                'tipo de producto': '',
                'otra categoría': '',
            },
            classifiedAttributes: {
                'linea de negocio': [],
                'canal': [],
                'proyecto': [],
                'tipo de producto': [],
            },
            loading: false,
            company_id: '',
            updatedAttrib: null,
            nameBeforeUpdate: '',
        };
    },
    methods: {
        addAttribute(attributeType, idUpdatedAttrib = null) {
            this.loading = true
            if (attributeType == 'otra categoría') {
                attributeType = this.auxInput[attributeType]
            }

            let attrib = {
                type: attributeType,
                name: this.auxInput[attributeType] || '',
                company_id: this.company_id,
            }

            if (idUpdatedAttrib) {
                attrib.id = idUpdatedAttrib
                attrib.name = attrib.name == '' ? this.updatedAttrib.name : attrib.name
            }

            if (attrib.name.includes('_') || attrib.name.includes(';') ||
                attrib.type.includes('_') || attrib.type.includes(';')) {
                notificate(
                    `<strong>No ingresar los siguientes datos: ; _`,
                    "is-danger is-light",
                );
                return
            }

            if (this.classifiedAttributes[attributeType]) {
                this.classifiedAttributes[attributeType].forEach(elem => {
                    if (elem.name == '') {
                        attrib.id = elem.id
                        return
                    }
                });
            }

            addAttributes(attrib).then(({ data }) => {
                let msg = "Se agrego correctamente"
                const updated = this.allAttributes.find(att => att.id === data.id)
                if (updated) {
                    updated.name = data.name
                    msg = "Se actualizo correctamente"
                } else {
                    this.allAttributes.push(data)
                }

                notificate(
                    `<strong>${msg} a
                         ${data.name || data.type}`,
                    "is-success is-light"
                );
            }).catch((error) => {
                consoleHandlerError({ error, empty: false });
            }).finally(() => {
                this.cleanInputs()
                this.updatedAttrib = null
                this.initClassifiedAttributes()
            })
        },
        getCategoryTypes() {
            let objectTypes = [{
                type: 'linea de negocio'
            }, {
                type: 'canal'
            }, {
                type: 'proyecto'
            }, {
                type: 'tipo de producto'
            }]
            for (let iAttrib = 0; iAttrib < this.allAttributes.length; iAttrib++) {
                const category = this.allAttributes[iAttrib];
                if (objectTypes.some(oType => oType.type === category.type)) {
                    continue
                }
                objectTypes.push({
                    type: category.type,
                })
            }
            objectTypes.push({
                type: 'otra categoría'
            })
            return objectTypes
        },
        initClassifiedAttributes() {
            const objectTypes = this.getCategoryTypes()
            objectTypes.forEach(oType => {
                this.classifiedAttributes[oType.type] = []
                this.auxInput[oType.type] = ''
            });
            this.allAttributes.forEach(attrib => {
                this.classifiedAttributes[attrib.type].push(attrib)
            });
        },
        editAttribute(attribute) {
            this.cleanInputs()
            if (attribute) {
                this.nameBeforeUpdate = attribute.name
                this.updatedAttrib = { ...attribute }
            } else {
                this.updatedAttrib.name = this.nameBeforeUpdate
                this.nameBeforeUpdate = ''
                this.updatedAttrib = null
            }

        },
        deleteAttribute(attrib) {
            deleteAttributes(attrib, this.company_id).then(({ status }) => {
                if (status == 204) {
                    const iAttrib = this.allAttributes.indexOf(attrib)
                    this.allAttributes.splice(iAttrib, 1)
                    this.initClassifiedAttributes()
                    notificate(
                        `< strong > Se elimino correctamente a
                         ${attrib.name}`,
                        "is-success is-light"
                    );
                } else {
                    throw new Error("No se pudo eliminar");
                }
            }).catch((error) => {
                consoleHandlerError({ error, empty: true });
            })
        },
        cleanInputs() {
            Object.keys(this.auxInput).forEach(keyInput => {
                this.auxInput[keyInput] = ''
            });
            this.loading = false
            this.auxInput = { ...this.auxInput }
        }
    },
};
</script>